import React from 'react';
import DoorlyProLayout, { RequirePartnerAuth } from '../../components/DoorlyProLayout';
import { useDoorlyProAuth } from '../../context/DoorlyProAuthContext';
import EligibilityChecker from '../../components/EligibilityChecker';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// The partner shell around the shared checker.
//
// ⚠️ THE BODY MOVED TO components/EligibilityChecker.jsx SO DOORLYDESK COULD
// SHOW THE SAME THING. Do not re-inline it: the component renders the AFM matrix
// and carries the fallback constants, and a second copy would drift from this
// one without anything failing — a partner and a staff member would be told
// different numbers for the same buyer. See the note at the top of that file.
export default function DoorlyProEligibility() {
  const { token } = useDoorlyProAuth();
  return (
    <RequirePartnerAuth>
      <DoorlyProLayout>
        <EligibilityChecker
          token={token}
          chatEndpoint={`${API_URL}/api/doorlypro/eligibility-chat`}
        />
      </DoorlyProLayout>
    </RequirePartnerAuth>
  );
}
